<kgr-page-title title="Login" i18n-title></kgr-page-title>

@if (userCredentials$ | async) {
  <div class="kgr-alert kgr-alert--info">
    <div class="kgr-row" i18n>Bereits eingeloggt.</div>
    <a routerLink="/user/logout" class="kgr-button" i18n>Ausloggen</a>
  </div>
} @else {
  <div class="kgr-region">
    <h2 class="kgr-headline kgr-headline--h2 kgr-headline--text kgr-headline--firstInText" i18n>Bitte zunächst einloggen</h2>
    <kgr-login-form (loginResult)="onLoginResult($event)"></kgr-login-form>
  </div>
}
